if (typeof JW === 'undefined') JW = {};
JW.Page = (function ($)
{
    var _pri = {};
    var publ = {};

    const State = JW.State;

    _pri.cname = 'PAGE';
    _pri.opts = {
        cln_v: '1.0.0',
        dbg_lvl: 1,
        dp_opts: {
            autoclose:             true,
            calendarWeeks:         true,
            daysOfWeekHighlighted: '[0,6]',
            format:                'dd.mm.yyyy',
            language:              'de',
            todayBtn:              'linked',
            todayHighlight:        true,
            weekStart:             1,
            templates: {
                leftArrow:  '<i class="fa fa-chevron-left"></i>',
                rightArrow: '<i class="fa fa-chevron-right"></i>'
            }
        },
        atk: 'pk.eyJ1Ijoiam9iZXJ5IiwiYSI6ImNpcW11OTU3dzAwMnJoeW5tc3l0bHhkdTQifQ.XmVlWN_sEQoGCk82CJTMgg', // mapbox accesToken for geocoding and map tiles
        geo_url: 'https://api.mapbox.com/geocoding/v5/mapbox.places/{QUERY}.json?access_token=pk.eyJ1Ijoiam9iZXJ5IiwiYSI6ImNpcW11OTU3dzAwMnJoeW5tc3l0bHhkdTQifQ.XmVlWN_sEQoGCk82CJTMgg',
        gep_rxp: /\{QUERY\}/
    };

    _pri.$cxc           = null;
    _pri.wwbuff         = _pri.whbuff = -1; // window dimensions, to prevent useless resize runs

    _pri.mods           = new Map();
    _pri.map_inited     = false;
    _pri.map_visible    = true;

    _pri.mapws_inited   = false;
    _pri.glls_inited    = false;
    _pri.live_inited    = false;
    _pri.sioc_inited    = false;
    _pri.cbds_inited    = false;
    _pri.pdfs_inited    = false;
    _pri.pdfs_loaded    = 0;
    _pri.cols2_inited   = false;
    _pri.cols2l_height  = 0;
    _pri.device         = 0;
    _pri.ios_safari     = -1;
    _pri.ponl           = '';
    _pri.ponljsn        = '';
    _pri.ili            = false;            // is logged in
    _pri.phone_mode     = false;            // mobile phone affix nav
    _pri.scrollbar_size = null;             // scrollbar dimensions e.g. [15, 15]
    _pri.inited         = false;
    _pri.state          = State.STATE_NONE;
    _pri.inited_geo     = false;
    _pri.geo_reload     = false;
    _pri.ggo_url        = '';
    _pri.scrl_state     = -1;                // -1 uninitialized, 0 big nav, 1 small nav, 2 force small
    _pri.map_view       = false;
    _pri.suspend_resize = false;
    _pri.locate_to      = false;
    _pri.omit_locate    = false;
    _pri.mco_pr         = 0;                // mco padding right
    _pri.on_q           = new Map();        // idstr -> {nm, cb} // registered event handlers before xcx - will be (re-)registered after onLoad()
    _pri.$pdt           = [];
    _pri.mutObs         = null;

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    _pri.onLocateSucc = function(pos)
    {
        _pri.dbgG('*** onLocateSucc()');
        // _pri.dbg(pos);
        if (_pri.locate_to)
        {
            clearTimeout(_pri.locate_to);
            _pri.locate_to = false;
        }

        var lat  = pos.coords.latitude;
        var lng  = pos.coords.longitude;
        var ll = L.latLng(lat, lng);
        _pri.getNameToLL(ll);
    };

    _pri.onLocateErr = function(err)
    {
        _pri.dbg('*** onLocateErr()');
        _pri.dbg('    err:', err);
        if (_pri.locate_to)
        {
            clearTimeout(_pri.locate_to);
            _pri.locate_to = false;
        }

        _pri.getWithGeo(L.latLng(53.55, 10.0167), '');
    };

    _pri.getNameToLL = function(ll)
    {
        _pri.dbg('*** getNameToLL()');

        var t = $.now();
        /*
         * commented to prevent sform states with empty ql
         *
        if (_pri.t_get_name + 1000 > t)
        {
            return;
        }
        */
        _pri.t_get_name = t;
        var llr = _pri.roundLL(ll, 5);
        var types_str = 'country,region,postcode,place';
        var uquery = encodeURIComponent(llr.lng + ',' + llr.lat);
        $.get(_pri.getQueryUrl(uquery, ('&types=' + types_str))).done(function(ret) {
            _pri.dbg('*** getNameToLL done()');
            //_pri.dbg('ret', ret);
            //_pri.dbg('ret.features', ret.features);
            //_pri.dbg('uquery', uquery);
            if (ret && typeof ret == 'object' && $.isArray(ret.features) && ret.features.length > 0)
            {
                //_pri.dbg('       * ', ret.features[0]);
                _pri.getWithGeo(ll, ret.features[0].text);
            }
            else
            {
                _pri.getWithGeo(ll, '');
            }
        });
    };

    _pri.getQueryUrl = function(query, qery_params_str)
    {
        // _pri.dbg('*** getQueryUrl()');
        // _pri.dbg('    query: ', query, 'qery_params_str: ', qery_params_str);
        // _pri.dbg('    url: ', _pri.opts.url.replace(_pri.opts.query_rxp, query) + qery_params_str);
        return _pri.opts.geo_url.replace(_pri.opts.gep_rxp, query) + qery_params_str;
    };

    _pri.getWithGeo = function(ll, name)
    {
        var opts = {
            type: 'GET',
            url: '/_ggo/' + ll.lat + '/' + ll.lng + '/' + encodeURIComponent(name),
            dataType: 'html'
        };

        $.ajax(opts).done(function(ret, stat_str, jq_xhr) {
            _pri.dbg('*** getWithGeo(' + opts.url + ') done');
            // _pri.dbg('    ret:', ret);
            if (jq_xhr.status == 200)
            {
                if (!_pri.geo_reload)
                {
                    publ.setPart('mco_geo', ret);
                }
                else
                {
                    _pri.dbg('    now load ggo_url:   ', _pri.ggo_url);
                    window.location.href = _pri.ggo_url;
                }
            }
        });
    };

    publ.onReady = function()
    {
        _pri.dbgG('*** onReady() cln_v:', _pri.opts.cln_v);

        if (_pri.inited)
        {
            _pri.dbgR('    !!! already inited!');
            return;
        }

        if (!_pri.inited_geo)
        {
            _pri.inited_geo = true;

            var $geoip = $('.geoip');
            if ($geoip.length > 0)
            {
                _pri.dbg('    locate ...');
                $geoip.removeClass('geoip');
                _pri.geo_reload = $geoip.data('lrl');
                _pri.ggo_url    = window.location.href;
                _pri.dbg('    geo_reload:', _pri.geo_reload);
                _pri.dbg('    ggo_url:   ', _pri.ggo_url);

                // disabled 20190119
                // var uarx = /Googlebot|Mediapartners-Google|AdsBot-Google|APIs-Google|Google Search Console|Google Page Speed/i;
                // if (uarx.test(navigator.userAgent))
                // {
                //     _pri.omit_locate = true;
                // }

                // _pri.dbg('navigator.geolocation', typeof navigator.geolocation);
                // _pri.dbg('navigator.geolocation.getCurrentPosition', typeof navigator.geolocation.getCurrentPosition);

                if (!_pri.omit_locate && typeof navigator.geolocation === 'object' && typeof navigator.geolocation.getCurrentPosition === 'function')
                {
                    navigator.geolocation.getCurrentPosition(_pri.onLocateSucc, _pri.onLocateErr, {
                        enableHighAccuracy: true,
                        maximumAge: 30000,
                        timeout: 10000
                    });
                    _pri.locate_to = setTimeout(function() {
                        _pri.onLocateErr({ code: 999, message: "Geolocation service timed out without error handler been called." });
                    }, 12000);
                }
                else
                {
                    _pri.onLocateErr({ code: 888, message: "Geolocation services are not supported by your web browser." });
                }

                return;
            }
        }

        _pri.inited = true;

        _pri.$body      = $('body');
        _pri.device     = _pri.$body.data('dvc');
        _pri.ponl       = _pri.$body.data('ponl');
        _pri.ili        = _pri.$body.data('ili') === true ? true : false;
        _pri.map_view   = _pri.$body.hasClass('map_view_cls');
        _pri.dbg('    _pri.map_view:', _pri.map_view);
        // _pri.dbg('_pri.ili', _pri.ili, typeof _pri.ili, _pri.ili === true);

        // load indicator
        _pri.$ind = $('<div id="prl"><div class="spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div></div>');
        // backdrop - should go to jw_modal ...
        _pri.$bd  = $('<div class="mbd fade show"></div>');
        _pri.err_html = '\
        <div class="hbg alert-danger fade show animated fadeIn">\
            <div class="con row py-3">\
                <div class="col">\
                    <div class="row">\
                        <div class="col-sm-1 pb-2 pb-sm-0">\
                            <i class="fa fa-3x fa-exclamation-circle text-danger" aria-hidden="true"></i>\
                        </div>\
                        <div class="col-sm-11">\
                            {ERRMSG}\
                        </div>\
                    </div>\
                </div>\
            </div>\
        </div>';

        _pri.$cxc = $('#cxc');
        if (_pri.$cxc.length == 0)
        {
            _pri.dbg('    no cxc!!!');
            _pri.$cxc = null;
        }
        else
        {
            _pri.ponljsn = _pri.$cxc.data('ponljsn');
        }

        _pri.$win          = $(window);
        _pri.$doc          = $(document);
        _pri.$nav_top      = $('#nav-top');      // navbar top
        _pri.$nav_top_main = $('#nav-top-main'); // navbar top first row
        _pri.$nav_top_sub  = $('#nav-top-sub');  // navbar top submenu
        _pri.$mco          = $('#mco');          // main content
        _pri.$nav_bot      = $('#nav-bot');      // footer
        _pri.$nav_adm      = $('#nav-adm');
        _pri.$pdt          = $('.pdt');

        _pri.initMapVals();

        _pri.$cols2         = $('#cols2');
        if (_pri.$cols2.length > 0)
        {
            _pri.$cols2l = _pri.$cols2.find('.cols2l');
        }

        // _pri.lstore   = $.localStorage;
        //_pri.dbg(publ.lstore.keys());

        _pri.initRpl();
        _pri.initAccs();
        _pri.initInputs();
        // _pri.initRatings();
        _pri.initCbToggles();
        _pri.initFileBtns();
        _pri.initRadioToggles();
        // _pri.initDstSlds();
        _pri.initSlds();
        _pri.initEvents();

        JW.GeoC.init();
        JW.SForm.init();
        JW.Modal.init();

        _pri.initAjxForms();
        _pri.initWClouds();
        _pri.initNavUsr();
        _pri.initPageScroll();
        _pri.initAld();
        // _pri.initGll();

        //_pri.dbg('_pri.ponl: ', _pri.ponl);
        if (typeof _pri.ponl !== 'undefined')
        {
            _pri.pOnl();
        }
        if (typeof JW.Adm !== 'undefined')
        {
            JW.Adm.init();
        }
        if (_pri.isObj(_pri.ponljsn))
        {
            JW.Modal.handleJSONRet(_pri.ponljsn);
            _pri.ponljsn = '';
        }

        // toggle css class
        $('.tglcls-btn').on('click', function(e) {
            e.stopPropagation();
            e.preventDefault();
            var $this = $(this);
            var cls = $this.data('cls');
            var $tgt = $($this.data('tgt'));
            if ($tgt.hasClass(cls))
            {
                $tgt.removeClass(cls);
                // JW.Modal.setMask(0, 2);
            }
            else
            {
                $tgt.addClass(cls);
                // JW.Modal.setMask(1, 2);
            }
            return false;
        });

        $(document).on('click', '.onc', function(e) {
            var href = $(this).data('href');
            if (typeof href !== 'undefined' && href != '')
            {
                window.location.href = href;
            }
        });

        if ( document.readyState === "complete" )
        {
            _pri.onLoad();
        }
        else
        {
            _pri.$win.on('load', _pri.onLoad);
        }

        // $('#lgo').click(_pri.mbtnClick);
        // $('#mbtn').click(_pri.mbtnClick);

        _pri.$win.scroll(_pri.onScroll);
        _pri.$win.on("resize", $.throttle(250, _pri.resize));

        // inputs with clear icon
        _pri.$doc.on('click', '.clri', function(e) {

            _pri.dbgG('*** clri click');
            var $this = $(this);
            var l = parseInt(e.pageX + 24 - $this.offset().left - $this.width());
            _pri.dbg('    l:', l);
            if (l >= 0)
            {
                var $tin = $this.find('input[type="text"], input[type="time"]');
                if ($tin.length > 0)
                {
                    $tin.val('');
                    publ.trigger('page:clri_click', $tin);
                    return false;
                }

                _pri.dbg('    check for select ...');
                $tin = $this.find('select');
                if ($tin.length > 0)
                {
                    _pri.dbg('    ... deselect all ...');
                    $tin.find('option').prop('selected', false);
                    $tin.trigger('change');
                    publ.trigger('page:clri_click', $tin);
                    return false;
                }
            }
        });

        // _pri.$doc.on( "click", ".mbd", function(e) {
        //     _pri.mbtnClick(e);
        // });

        // $('.mbd').on( "click", function(e) {
        //     _pri.mbtnClick(e);
        // });

        _pri.state = State.STATE_READY;
    };

    publ.isMapView = function()
    {
        _pri.dbgG('*** isMapView()');
        let len = $('.map_view_cls').length;
        if (len == 1)
        {
            return true;
        }
        else if (len > 1)
        {
            _pri.dbgR('!!! isMapView length > 1!?');
        }

        return false;
    };

    publ.initElm = function(sel, arr)
    {
        _pri.dbg('*** initElm()', sel, arr);

        $elms = $(sel);
        if ($elms.length > 0 && $.isArray(arr) && arr.length > 0)
        {
            _pri.dbg('    yup', arr);
            $.each($elms, function(kelm, velm) {
                $elm = $(velm);
                $.each(arr, function(k, v) {
                    _pri.dbg('    ... case:', v);

                    switch (v)
                    {
                        // case 'collapse':
                        //     $elm.find('.collapse').collapse({toggle: false});
                        // break;
                        case 'acc':
                            let $acc = $elm.find('.acc');
                            if ($acc.length > 0)
                            {
                                _pri.initAcc($acc);
                            }
                        break;
                        case 'afrm':
                            _pri.initAjxForms($elm);
                        break;
                        case 'jbsel':
                            // var $input = $elm.find('[class="jb-select"]');
                            // why only :not(.nai) (former single class)??? so it's not possible to explicitly init those ...
                            // nai: no auto init
                            var $input = $elm.find('.jb-select:not(.nai)');
                            $.each($input, function(k2, v2) {
                                //_pri.dbg(k2);
                                //_pri.dbg(v2);
                                JW.InpSelect(jQuery, v2);
                            });
                        break;
                        case 'fbtn':
                            var $fbtn = $elm.find('.jw-file-btn');
                            $fbtn.each(function(k, v) {
                                var $this = $(this);
                                publ.initFileBtn($this);
                            });
                        break;
                        case 'tooltip':
                            $('.tooltip').tooltip('hide');
                            // let $toop = $elm.find('[data-toggle="tooltip"]');
                            // _pri.dbg('    lehth:', $toop.length);
                            $elm.find('[data-toggle="tooltip"]').tooltip({html: true});
                        break;
                        case 'datepicker':
                            $elm.find('.datepicker:not(.nai)').each(function (k2, v2) {
                                // _pri.dbg('######## datepicker: ', k2, v2);
                                var $dp = $(v2);
                                var opts = $.extend({}, _pri.opts.dp_opts);
                                var dmode = $dp.data('dmode');
                                // _pri.dbg('    #### dmode: ', dmode);
                                if (dmode == 'm')
                                {
                                    opts.format      = 'mm yyyy';
                                    opts.startView   = 'months';
                                    opts.minViewMode = 'months';
                                }
                                // _pri.dbg('    #### opts: ', opts);
                                $dp.datepicker(opts);
                            });
                        break;

                        case 'gll':
                            if ($('#jwgll').length > 0)
                            {
                                _pri.dbg('    found gll div - call init(force)');
                                _pri.glls_inited = true;
                                JW.JWGll.init(true);
                            }
                        break;

                        case 'ta-tx':
                            var $input = $elm.find('.ta-tx');
                            $.each($input, function(k, v) {
                                //_pri.dbg(k);
                                //_pri.dbg(v);
                                JW.TATextInput(jQuery, v);
                            });
                        break;

                        case 'mutobs':
                            let $obs = $elm.find('.mutobs');
                            if ($obs.length > 0)
                            {
                                _pri.setMutObs($obs);
                            }
                        break;

                        case 'ecll':
                            _pri.initECll($elm);
                        break;

                        case 'cltree':
                            $input = $elm.find('.cltree:not(.nai)');
                            $.each($input, function(k, v) {
                                //_pri.dbg(k);
                                //_pri.dbg(v);
                                JW.ClTree(jQuery, v);
                            });
                        break;

                        // fair map
                        case 'map':
                            _pri.initMapView();
                        default:

                        break;
                    }
                });
            });
        }
    };

    publ.scrolledInView = function ($elm, full)
    {
        var page_top = $(window).scrollTop() + _pri.$nav_top.outerHeight(true);
        var page_bot = page_top + $(window).outerHeight(true);
        var elm_top = $elm.offset().top;
        var elm_bot = elm_top + $elm.outerHeight();

        if (typeof full === 'boolean' && full === true)
        {
            return ((page_top < elm_top) && (page_bot > elm_bot));
        }

        return ((elm_top <= page_bot) && (elm_bot >= page_top));
    };

    publ.getState = function()
    {
        return _pri.state;
    };

    _pri.onLoad = function ()
    {
        _pri.dbgG('*** onLoad()');

        _pri.resize();
        _pri.onScroll();

        // $('#prl').fadeOut('slow', function() {
        //     _pri.$cxc.trigger('page:show');
        //     $(this).remove();
        // });

        _pri.$cxc.trigger('page:show');
        $('#prl').remove();

        // $('#prl').fadeOut(400, function() {
        //     _pri.$cxc.trigger('page:show');
        //     $(this).remove();
        // });

        _pri.loadDefers();
        _pri.initECll('PAGE_INIT');
        _pri.initMutObs();

        $('[data-toggle="tooltip"]').tooltip();
        // datepicker no not automatically initialized
        // $('.datepicker:not(.nai)').datepicker(_pri.opts.dp_opts);
        $('.datepicker:not(.nai)').each(function (k, v) {
            // _pri.dbg('######## datepicker: ', k, v);
            var $dp = $(v);
            var opts = $.extend({}, _pri.opts.dp_opts);
            var dmode = $dp.data('dmode');
            // _pri.dbg('    #### dmode: ', dmode);
            if (dmode == 'm')
            {
                opts.format      = 'mm yyyy';
                opts.startView   = 'months';
                opts.minViewMode = 'months';
            }
            // _pri.dbg('    #### opts: ', opts);
            $dp.datepicker(opts);
        });

        $(document).on('click', '.poai', function() {
            $this = $(this);
            // '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
            _pri.dbg('    typeof po:', typeof $this.popover, 'data("bs.popover")', $this.data('bs.popover'));
            if (typeof $this.data('bs.popover') === 'undefined')
            {
                let cls = $this.data('po_cls');
                if (typeof cls === 'undefined')
                {
                    cls = '';
                }
                let tpl = '<div class="popover' + (cls == '' ? '' : ' ' + cls) + '" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>';
                $this.popover({
                    trigger: 'focus',
                    html:     true,
                    template: tpl
                });
                $this.popover("show");
            }
            else
            {
                // $this.popover("dispose");
            }
        });

        // $('.poai[data-toggle="popover"]').popover({
        //     // trigger: 'focus',
        //     html:    true
        // });
        // $('.popover-dismiss').popover({
        //     trigger: 'focus'
        // });
        // // generic quest pager - not handled by sfrm
        // $('select.gpgr').on('change', function(e)
        // {
        //     e.preventDefault();
        //     _pri.dbg('*** gpgr setRPP()');
        //     var val = $(this).val();
        //     if (typeof val !== 'undefined')
        //     {
        //         val = parseInt(val);
        //         if (val > 0)
        //         {
        //             _pri.dbg('    rpp: ', val);
        //         }
        //     }
        //     return false;
        // });

        // jump to page - generic FE pager - not handled by forms
        // _pri.$doc.on('change', 'select.jtp:not(.nai)', function(e) // does not work - reloads when initialized - at least with ajx ...
        $('select.jtp:not(.nai)').on('change', function(e)
        {
            e.preventDefault();
            // _pri.dbg('*** jtp change()');
            var $this = $(this);
            var val = $this.val();
            var href = $this.data('href');
            if (typeof val !== 'undefined' && typeof href !== 'undefined')
            {
                val = parseInt(val);
                if (val > 0)
                {
                    // _pri.dbg('    jtp: ', val);
                    var arr = href.split('?');
                    if (arr.length == 2)
                    {
                        window.location.href = arr[0] + val + '?' + arr[1];
                    }
                    else
                    {
                        window.location.href = href + val;
                    }
                }
            }
            return false;
        });

        // char counter, nai: no auto init
        let $chcnts = $('.inpchcnt:not(.nai)');
        $.each($chcnts, function(k, v) {
            // _pri.dbgR(k);
            // _pri.dbgR(v);
            JW.InpChcnt(jQuery, v);
        });

        // var str = 'Kammer ~\++ (IHK,HWK, Landwirtschaftskammer)$-/?ä!!';
        // var enc = _pri.rawurlencode(str);
        // var enc2 = _pri.rawurlencode(enc);
        // var dec2 = _pri.rawurldecode(enc2);
        // var dec = _pri.rawurldecode(dec2);
        // _pri.dbgB(str);
        // _pri.dbgB(enc);
        // _pri.dbgB(enc2);
        // _pri.dbgB(dec2);
        // _pri.dbgB(dec);

        if (_pri.on_q.size > 0)
        {
            _pri.dbgB('000 size:', _pri.on_q.size);
            _pri.dbg('    on_q ...');

            _pri.on_q.forEach(function(v, k) {

                if (typeof v.cb === 'function' && typeof v.enm === 'string' && v.enm.length > 0)
                {
                    publ.on(v.enm, v.cb);
                }

                _pri.on_q.delete(k);
            });
            _pri.dbgB('111 size:', _pri.on_q.size);
        }

        _pri.state = State.STATE_LOADED;

        _pri.dbg('*** trigger(page:load_done)');
        publ.trigger('page:load_done');
    };

    _pri.setScrlForce = function(force)
    {
        if (force)
        {
            _pri.scrl_state = 2;
            $('.pdt').addClass('pdt_min');
            _pri.$body.addClass('scrl');
        }
        else
        {
            _pri.scrl_state = -1;
            $('.pdt').removeClass('pdt_min');
            _pri.setScrlCls();
        }
    };

    _pri.setScrlCls = function()
    {
        if (_pri.scrl_state < 2)
        {
            if (_pri.$win.scrollTop() < 44)
            {
                if (_pri.scrl_state == -1 || _pri.scrl_state == 1)
                {
                    _pri.scrl_state = 0;
                    // _pri.$nav_top.removeClass('scrl');
                    _pri.$body.removeClass('scrl');

                    // setTimeout(function(){publ.resize();}, 200);
                }
            }
            else if (_pri.$win.scrollTop() >= 44)
            {
                if (_pri.scrl_state == -1 || _pri.scrl_state == 0)
                {
                    _pri.scrl_state = 1;
                    // _pri.$nav_top.addClass('scrl');
                    _pri.$body.addClass('scrl');

                    // setTimeout(function(){publ.resize();}, 200);
                }
            }
        }
    };

    _pri.onScroll = function(e)
    {
        _pri.setScrlCls();

        // TODO set top to viewport top ...
        if (_pri.device == 0 && _pri.$nav_adm.length > 0 && typeof _pri.whbuff !== 'undefined')
        {
            // _pri.dbgR('top?', _pri.$nav_adm.css('top'));
            let pdt_h = 0;
            if (_pri.$pdt.length == 0)
            {
                pdt_h = 88;
            }

            if (JW.ViewPort.getWidth() >= 1605)
            {
                if (_pri.$win.scrollTop() > 60)
                {
                    let naadm_h    = _pri.$nav_adm.outerHeight(true);
                    let nabot_offt = _pri.$nav_bot.offset().top;
                    let scrolltop  = _pri.$win.scrollTop();

                    // _pri.dbg(scrolltop + naadm_h, ' :: ', nabot_offt);

                    if (scrolltop + naadm_h < nabot_offt - 60)
                    {
                        _pri.$nav_adm.css('top', pdt_h + scrolltop - 60);
                    }
                    else
                    {
                        _pri.$nav_adm.css('top', pdt_h + nabot_offt - naadm_h - 120);
                    }
                }
                else
                {
                    _pri.$nav_adm.css('top', pdt_h);
                }
            }
            else if (typeof _pri.$nav_adm.css('top') !== 'undefinde' && _pri.$nav_adm.css('top') != '0px')
            {
                // _pri.dbgR('!!!NOW!');
                _pri.$nav_adm.css('top', pdt_h);
            }
        }
    };

    _pri.initPageScroll = function()
    {
        $('a.pscrl').on('click', function(e) {

            var $this = $(this);

            _pri.dbg('    this: ', $this);
            _pri.dbg('    scrollTop: ', $(window).scrollTop());
            // if ($(window).scrollTop() > 100 && $this.length > 0 && typeof($this[0].hash) != 'undefined' && $this[0].hash == '#page-top')
            // {
            //     introAni();
            // }
            $('html, body').stop().animate({
                scrollTop: ($($this.attr('href')).offset().top - 50)
            }, 1250, 'easeInOutExpo' );

            e.preventDefault();
        });
    };

    // _pri.onScrollNavTop = function(e)
    // {
    //     if (_pri.$nav_top.scrollTop() <= 2)
    //     {
    //         if (_pri.scrl_state)
    //         {
    //             _pri.scrl_state = false;
    //             _pri.$nav_top.removeClass('scrl');
    //             _pri.$body.removeClass('scrl');
    //
    //             // setTimeout(function(){publ.resize();}, 200);
    //         }
    //     }
    //     else if (_pri.$nav_top.scrollTop() >= 4)
    //     {
    //         if (!_pri.scrl_state)
    //         {
    //             _pri.scrl_state = true;
    //             _pri.$nav_top.addClass('scrl');
    //             _pri.$body.addClass('scrl');
    //
    //             // setTimeout(function(){publ.resize();}, 200);
    //         }
    //     }
    // };

    // _pri.mbtnClick = function(e)
    // {
    //     if (typeof e === 'object' && typeof e === 'function')
    //     {
    //         e.preventDefault();
    //     }
    //
    //     _pri.dbg('#mbtn.click()');
    //
    //     if (_pri.$body.hasClass('modal-open'))
    //     {
    //         _pri.dbg('    hasClass modal-open - hide sub menu');
    //
    //         // _pri.$nav_top.off('scroll', _pri.onScrollNavTop);
    //         // _pri.$nav_top.addClass('scrl');
    //         _pri.$bd.remove();
    //         _pri.$body.removeClass('modal-open');
    //         $('#nav-top-sub').collapse('hide');
    //         _pri.$nav_top.css('overflow-y', '');
    //         _pri.$nav_top.css('height', '');
    //         _pri.onScroll();
    //     }
    //     else
    //     {
    //         _pri.dbg('    not hasClass modal-open - show sub menu');
    //
    //         // _pri.scrl_state = true;
    //         // _pri.$nav_top.addClass('scrl');
    //         // _pri.$body.addClass('scrl');
    //         _pri.$body.append(_pri.$bd);
    //         _pri.$body.addClass('modal-open');
    //
    //         $('#nav-top-sub').collapse('show');
    //         _pri.$nav_top.css('overflow-y', 'auto');
    //         _pri.$nav_top.css('max-height', '100%')
    //         // _pri.$nav_top.css('height', '100%');
    //         // _pri.onScrollNavTop();
    //         // _pri.$nav_top.on('scroll', _pri.onScrollNavTop);
    //     }
    //
    //     return false;
    // };

    publ.tests = function()
    {
        // var gp = new GeoPoint(52.247, 9.87412, false);
        // _pri.dbg(gp);
        //
        // var dist = $('#qd').val();
        // _pri.dbg('dist', dist);
        //
        // var arr = gp.boundingCoordinates(parseInt(dist), true);
        // _pri.dbg(arr);
        // JW.SForm.tests();
        // publ.showLoading();
        //
        // if (publ.getRndmInt(0, 1) > 0)
        // {
        //     _pri.$cxc.trigger('sform:loading_jobs');
        // }
        // else
        // {
        //     _pri.$cxc.trigger('sform:loading_jobs_done');
        // }
        //
        //
        // JW.Page.on('page:test', function(e, o) {
        //     _pri.dbg('on page:test', e, o);
        // });
        //
        // JW.Page.trigger('page:test', {aba: 'obo'});
        //
        //
        // JW.Modal.get('login');
        //
        // JW.GeoC.getLLToAddress('Brennerstraße 1, Hamburg 20099');
        // var addr = {street: 'Brennerstraße', street_no: '1', zip: '20099', city: 'Hamburg', cc: 'DE'};
        // JW.GeoC.getLLToAddress(addr);

        // JW.Modal.get('/preise');
    };

    publ.on = function(enm, cb, idstr)
    {
        // _pri.dbgR('*** page on', enm, 'idstr:', idstr);
        if (_pri.inited && _pri.isObj(_pri.$cxc))
        {
            // _pri.dbgR('    YUP!');
            _pri.$cxc.on(enm, cb);
        }
        else if (typeof idstr === 'string' && idstr.length > 7)
        {
            _pri.dbgR('    NOPE ... queue it ...');
            _pri.dbgB('000 size:', _pri.on_q.size);
            _pri.on_q.set(idstr, {enm: enm, cb: cb});
            _pri.dbgB('111 size:', _pri.on_q.size);
        }
    };

    publ.off = function(enm, cb, idstr)
    {
        // _pri.dbgR('*** page off', enm, 'idstr:', idstr);
        if (_pri.inited && _pri.isObj(_pri.$cxc))
        {
            _pri.$cxc.off(enm, cb);
        }
        else if (typeof idstr === 'string' && idstr.length > 7)
        {
            _pri.dbgR('    NOPE ... delete it from queue ...');
            _pri.dbgB('000 size:', _pri.on_q.size);
            _pri.on_q.delete(idstr);
            _pri.dbgB('111 size:', _pri.on_q.size);
        }
    };

    publ.trigger = function(enm, o)
    {
        // _pri.dbgR('*** page trigger', enm, o);
        if (_pri.inited && _pri.isObj(_pri.$cxc))
        {
            _pri.dbg('    cxc.triggered ...');
            _pri.$cxc.trigger(enm, o);
        }
    };

    publ.setPart = function(part, html)
    {
        switch (part)
        {
            case 'nav-top':
                _pri.$nav_top.html(html);
                _pri.$nav_top_main = $('#nav-top-main');
                _pri.$nav_top_sub  = $('#nav-top-sub');
                _pri.initNavUsr();
            break;
            case 'job_page_1':
                var $cbdedt = $('#cbd');
                _pri.dbg('    $cbdedt: ', $cbdedt);
                if ($cbdedt.length > 0)
                {
                    var jw_cbd = $cbdedt.data('jw_cbd');
                    _pri.dbg('    jw_cbd', jw_cbd);
                    if (typeof jw_cbd === 'object')
                    {
                        _pri.dbg('    destroy jw_cbd ...');
                        jw_cbd.destroy();
                        delete jw_cbd;
                    }
                }
                $('#divCb').remove();
                $('#job_pages').empty().html(html);
                var $acc = $('#cbd-frm-bot').find('.acc');
                if ($acc.length > 0)
                {
                    _pri.initAcc($acc);
                }
                var $ftbn = $('#cbd-frm-bot').find('.jw-file-btn');
                $ftbn.each(function(k, v) {
                    var $this = $(this);
                    publ.initFileBtn($this);
                });
                var $jobfrm = $('#cbd-frm-bot');
                if ($jobfrm.length > 0)
                {
                    JW.JobFrm(jQuery, $jobfrm[0]);
                }
            break;
            case 'job_page_2':
                window.scrollTo(0, 0);

                var $jobfrm = $('#cbd-frm-bot');
                if ($jobfrm.length > 0)
                {
                    var jw_job_frm = $jobfrm.data('jw_job_frm');
                    if (typeof jw_job_frm === 'object')
                    {
                        _pri.dbg('    destroy jw_job_frm ...');
                        jw_job_frm.destroy();
                        delete jw_job_frm;
                    }
                }

                $('#job_pages').empty().html(html);
                var $cbdedt = $('#cbd');
                if ($cbdedt.length > 0)
                {
                    JW.Cbd(jQuery, $cbdedt[0]);
                }
                publ.initPdfWrps('#job_pages');
                // $('html,body').animate({
                //     scrollTop: 0
                // }, 350);
            break;
            case 'job_page_3':
                var $cbdedt = $('#cbd');
                _pri.dbg('    $cbdedt: ', $cbdedt);
                if ($cbdedt.length > 0)
                {
                    var jw_cbd = $cbdedt.data('jw_cbd');
                    _pri.dbg('    jw_cbd', jw_cbd);
                    if (typeof jw_cbd === 'object')
                    {
                        _pri.dbg('    destroy jw_cbd ...');
                        jw_cbd.destroy();
                        delete jw_cbd;
                    }
                }
                $('#divCb').remove();
                $('#job_pages').empty().html(html);
            break;
            case 'mco_geo':
                $('#mco').empty().html(html);
                publ.onReady();
            break;
            default:

            break;
        }

        publ.trigger('page:set_part_done', {part: part});
    };

    publ.isIE = function()
    {
        return (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1);
    };

    publ.isIosSafari = function()
    {
        if (_pri.ios_safari === -1)
        {
            _pri.ios_safari = false;

            if (publ.isMobile)
            {
                var ua = navigator.userAgent;
                var ios = ((/iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) && !window.MSStream);
                if (ios)
                {
                    _pri.ios_safari = !/CriOS/.test(ua) && !/FxiOS/.test(ua) && !/OPiOS/.test(ua) && !/mercury/.test(ua);
                }
            }
        }

        return _pri.ios_safari;
    };

    publ.isMobile = function()
    {
        return parseInt(_pri.device) > 0;
    };

    publ.isPhone = function()
    {
        return parseInt(_pri.device) == 2;
    };

    publ.getDevice = function()
    {
        return _pri.device;
    };

    publ.isLoggedIn = function()
    {
        return _pri.ili;
    };

    publ.setLoggedIn = function(ili)
    {
        // _pri.dbg('******** setLoggedIn() ', ili);
        _pri.ili = ili;
    };

    publ.getATk = function()
    {
        return _pri.opts.atk;
    };

    publ.hasMap = function()
    {
        return _pri.map_inited && _pri.map_visible;
    };

    publ.getRndmInt = function(min, max)
    {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };

    publ.getUId = function(len)
    {
        var uid = '';
        var len = len || 16;
        for (var i = 0; i < len; ++i)
        {
            var r = Math.random()*16|0;
            uid += r.toString(16);
        }
        return uid;
    };

    publ.getUUId = function()
    {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    };

    publ.simpleHash = function(str)
    {
        var hsh = 0, len = str.length, chr, i;
        if (len === 0)
        {
            return hsh;
        }

        for (i = 0; i < len; ++i)
        {
            chr = str.charCodeAt(i);
            hsh = ((hsh << 5) - hsh) + chr;
            hsh &= hsh; // Convert to 32bit integer
        }
        return hsh;
    };

    // not used for now ...
    // publ.showLoading = function()
    // {
    //     if ($('body').has('#ind').length == 0)
    //     {
    //         $('body').append(_pri.$ind);
    //     }
    // };

    publ.isPhoneMode = function()
    {
        return _pri.phone_mode;
    };

    publ.getDocHeight = function()
    {
        var wh = _pri.$win.height();
        var hh = _pri.$nav_top.outerHeight();
        var fh = _pri.$nav_bot.outerHeight();

        return _pri.$mco.outerHeight(true) + fh;

        // if (_pri.$map.length > 0)
        // {
        //     var mq = window.matchMedia( "(min-width: 768px)" );
        //     if (mq.matches || _pri.$col_map.is(':visible'))
        //     {
        //         return wh;
        //     }
        //     else
        //     {
        //         var $col = _pri.$col_left.is(':visible') ? _pri.$col_left : _pri.$col_right;
        //         return $col.outerHeight(true) + hh + fh;
        //     }
        // }
        // else
        // {
        //     return _pri.$mco.outerHeight(true) + fh;
        // }
    };

    publ.getScrollBarSize = function()
    {
        if (!_pri.scrollbar_size)
        {
            _pri.scrollbar_size = $.getScrollBarSize();
        }

        return _pri.scrollbar_size;
    };

    publ.loadJS = function(url, cb, arg)
    {
        var tag = document.createElement('script');
        tag.type = 'text/javascript';
        tag.src = url;
        tag.onload = function (e) {
            //_pri.dbg('******** loadJS(' + url + ') onload');
            cb(arg, e);
        };

        document.head.appendChild(tag);
    };

    publ.loadCSS = function(url, cb, arg)
    {
        var tag = document.createElement('link');
        tag.rel = 'stylesheet';
        tag.type = 'text/css';
        tag.href = url;
        tag.onload = function (e) {
            //_pri.dbg('******** loadCSS(' + url + ') onload');
            if (typeof cb === 'function')
            {
                cb(arg);
            }
        };

        document.head.appendChild(tag);
    };

    publ.enterFs = function(el)
    {
        if (el.requestFullscreen)
        {
            el.requestFullscreen();
        }
        else if (el.mozRequestFullScreen)
        {
            el.mozRequestFullScreen();
        }
        else if (el.webkitRequestFullscreen)
        {
            el.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
        else if (el.msRequestFullscreen)
        {
            el.msRequestFullscreen();
        }
        else
        {
            _pri.dbg('!!! enter fs failed! ...');
            return false;
        }

        return true;
    };

    publ.exitFs = function()
    {
        if (document.exitFullscreen)
        {
            document.exitFullscreen();
        }
        else if (document.webkitExitFullscreen)
        {
            document.webkitExitFullscreen();
        }
        else if (document.mozCancelFullScreen)
        {
            document.mozCancelFullScreen();
        }
        else if (document.msExitFullscreen)
        {
            document.msExitFullscreen();
        }
        else
        {
            _pri.dbg('!!! exit fs failed! ...');
            return false;
        }

        return true;
    };

    publ.getFsElm = function()
    {
        var elm = null;

        if (document.fullscreenElement)
        {
            elm = document.fullscreenElement;
        }
        else if (document.mozFullScreenElement)
        {
            elm = document.mozFullScreenElement;
        }
        else if (document.webkitFullscreenElement)
        {
            elm = document.webkitFullscreenElement;
        }
        else if (document.msFullscreenElement)
        {
            elm = document.msFullscreenElement;
        }

        return elm;
    };

    _pri.loadDefers = function()
    {
        var $imgs = $('img.defer, iframe.defer');
        var $this;
        $imgs.each(function(k, v) {
            $this = $(this);
            $this.attr('src', $this.data('src'));
            $this.removeAttr("data-src");
            $this.removeClass('defer');
        });
    };

    _pri.ffxScrl = function()
    {
        if($(window).scrollTop() <= 50)
        {
            _pri.$ffx.removeClass('scrl');
        }
        else
        {
            _pri.$ffx.addClass('scrl');
        }
    };

    _pri.resize = function(e)
    {
        // if (typeof e !== 'undefined')
        // {
        //     _pri.dbg('*** resize() e: ', e)
        // }
        _pri.dbgG('*** _pri.resize()', 'suspend_resize?:', _pri.suspend_resize);

        if (_pri.suspend_resize)
        {
            return;
        }

        var wh = _pri.$win.height();
        var ww = _pri.$win.width();

        if (_pri.whbuff != wh || _pri.wwbuff != ww)
        {
            publ.resize(ww, wh);

            var hh = _pri.$nav_top.outerHeight();
            var fh = _pri.$nav_bot.outerHeight();

            var h = wh - hh - fh;

            if (publ.isMapView())
            {
                _pri.dbgY('    resize map view ...');

                if (!_pri.map_inited && _pri.isObj(JW.Map))
                {
                    _pri.dbg('    calling JW.MapSForm.init() JW.MapList.init() ...');
                    JW.MapSForm.init();
                    JW.MapList.init();
                }

                let h_map = wh - 44 - fh;
                _pri.dbgY('    h_map: ', h_map);

                var mq = window.matchMedia( "(min-width: 768px)" );
                if (mq.matches)
                {
                    _pri.dbgY('    >= 768');
                    _pri.$ccols.css('height', h_map + 'px');
                    _pri.$map.css('height', h_map + 'px');
                    _pri.$mfrm.css('height', h_map + 'px');
                    JW.Map.scheduleResize();
                    if (true) // _pri.phone_mode)
                    {
                        //_pri.dbg('*** leave phonemode');
                        $(window).off("scroll", _pri.ffxScrl);
                        _pri.$ffx.addClass('d-none');
                        _pri.phone_mode = false;
                        //_pri.$col_left.show();
                        //_pri.$col_map.show();
                        //_pri.$col_right.show();
                        JW.MapSForm.showCol(true);
                        JW.Map.showCol(true);
                        JW.MapList.showCol(true);
                    }
                }
                else
                {
                    _pri.dbgY('    < 768');

                    // _pri.$ccols.css('min-height', h_map + 'px');
                    // _pri.$ccols.css('height', '');
                    // _pri.$map.css('height', h_map + 'px');
                    _pri.$ccols.css('height', h_map + 'px');
                    _pri.$map.css('height', h_map + 'px');
                    _pri.$mfrm.css('height', h_map + 'px');

                    _pri.$ffx.removeClass('d-none');
                    _pri.$ffx.css('left', (((ww - _pri.$ffx.width()) / 2)) + 'px');
                    JW.Map.scheduleResize();
                    if (true) // !_pri.phone_mode)
                    {
                        //_pri.dbg('*** init phonemode');
                        _pri.phone_mode = true;
                        //_pri.$col_map.hide();
                        //_pri.$col_right.hide();

                        //JW.MapSForm.showCol(false);
                        //JW.Map.showCol(false);
                        //JW.MapList.showCol(false);
                        JW.MapSForm.ffxClick('#col-map');
                        $(window).scroll(_pri.ffxScrl);
                    }
                }

                if (!_pri.map_inited && _pri.isObj(JW.Map))
                {
                    _pri.dbg('    calling JW.Map.init() ...');
                    _pri.map_inited = true;
                    // done before ...
                    // JW.MapSForm.init();
                    // JW.MapList.init();
                    JW.Map.init();
                    publ.trigger('page:map_init');
                }
            }
            else
            {
                //_pri.dbg('no map');
                _pri.$ccol.css('min-height', h + 'px');
            }

            if (!_pri.mapws_inited)
            {
                _pri.mapws_inited = true;
                _pri.initMapWidgets();
            }

            if (!_pri.glls_inited)
            {
                if ($('#jwgll').length > 0)
                {
                    _pri.glls_inited = true;
                    _pri.initGll();
                }
            }
            if (!_pri.cbds_inited)
            {
                _pri.cbds_inited = true;
                _pri.initCbds();
            }
            if (!_pri.pdfs_inited)
            {
                _pri.pdfs_inited = true;
                _pri.initPdfs();
            }
            if (!_pri.live_inited)
            {
                _pri.live_inited = true;
                _pri.initLive();
            }
            if (!_pri.sioc_inited)
            {
                _pri.sioc_inited = true;
                _pri.initSioc();
            }

            _pri.dbg('*** trigger(page:resize_done)');
            publ.trigger('page:resize_done');
        }
    };

    _pri.beforeResize = function(before)
    {
        if (before == 'cols2')
        {
            _pri.$cols2 = $('#cols2');
            if (_pri.$cols2.length > 0)
            {
                _pri.$cols2l = _pri.$cols2.find('.cols2l');
            }
        }
    };

    publ.resize = function(ww, wh, before)
    {
        if (typeof before === 'string')
        {
            _pri.beforeResize(before);
        }
        // var $mco_con = _pri.$mco.find('> .con');
        // $mco_con.css('min-height', '');
        _pri.$mco.css('min-height', '');

        if (typeof ww === 'undefined')
        {
            ww = _pri.$win.width();
        }

        if (typeof wh === 'undefined')
        {
            wh = _pri.$win.height();
        }

        _pri.whbuff = wh;
        _pri.wwbuff = ww;

        // var dh = _pri.$doc.height();
        // var hh = _pri.$nav_top_main.outerHeight(true);
        var fh = _pri.$nav_bot.outerHeight(true);

        var h = wh - fh;
        _pri.dbgG('*** resize() wh fh', wh, fh);
        // _pri.dbg('    h: ' + h);

        if (_pri.$cols2.length > 0)
        {
            var rect = _pri.$nav_top_main[0].getBoundingClientRect();
            // _pri.dbg('    nav rect: ', rect);
            _pri.$cols2l.css('left', rect.left + 'px');

            // if (!_pri.cols2_inited)
            // {
            //     _pri.cols2l_height = _pri.$cols2l.outerHeight(true);
            //     _pri.$gll = $('#gll');
            // }
            // var h2 = _pri.cols2l_height + _pri.$gll.outerHeight(true) + 88;

            _pri.cols2l_height = _pri.$cols2l.outerHeight(true);
            // _pri.dbg('    cols2l_height', _pri.cols2l_height);

            var $c2t = $('.c2t');
            var th = 88;
            if ($c2t.length > 0)
            {
                th += $c2t.outerHeight(true);  // cols 2 top div
            }

            var h2 = _pri.cols2l_height + th;

            // _pri.dbg('    h2: ', h2);

            h = Math.max(h, h2);
        }

        var $out_navs = $('#nav-adm,#nav-usr');
        if ($out_navs.length > 0)
        {
            // _pri.dbg('    yup out navs ...');
            var mxh = -1;
            var h3;
            $out_navs.each(function() {
                h3 = $(this).outerHeight(true);
                // h3 = this.getBoundingClientRect().height;
                if (h3 > mxh)
                {
                    mxh = h3;
                    _pri.dbg('    set to ' + mxh);
                }
            });

            mxh += 135;
            // _pri.dbg('    ot mxh: ', mxh);
            h = Math.max(h, mxh);
        }

        // _pri.dbg('    mcoh: ' + _pri.$mco.outerHeight(true));

        // var nocont_h = 0;
        // _pri.$mco.find('> .ncon').each(function(k, v){
        //     nocont_h += $(v).outerHeight(true);
        // });

        // $mco_con.css('min-height', (h - nocont_h) + 'px');

        _pri.dbg('    finally mco min height:', h);
        _pri.$mco.css('min-height', (h) + 'px');

        // if ($(document).height() > wh)
        // {
        //     _pri.dbg('SCROLLLLLLLLLLLLLLLLLLLLLB');
        //     var sz = publ.getScrollBarSize();
        //     if (Array.isArray(sz))
        //     {
        //         _pri.mco_pr = sz[0];
        //         _pri.$mco.css('padding-right', sz[0] + 'px');
        //     }
        // }
        // else
        // {
        //     _pri.dbg('NOOOOOOOOOOOOOO SCROLLB');
        //     // _pri.$mco.css('padding-right', '');
        // }

        // correct after delay ...
        if ($out_navs.length > 0)
        {
            setTimeout(function() {
                // _pri.dbg('    yup out navs ...');
                var mxh = -1;
                var h3;
                $out_navs.each(function() {
                    h3 = $(this).outerHeight(true);
                    // h3 = this.getBoundingClientRect().height;
                    if (h3 > mxh)
                    {
                        mxh = h3;
                        // _pri.dbg('    set to ' + mxh);
                    }
                });

                mxh += 135;
                // _pri.dbg('    ot mxh: ', mxh);
                h = Math.max(h, mxh);

                _pri.dbg('    correct after delay: mco min height:', h);

                _pri.$mco.css('min-height', (h) + 'px');
            }, 200);
        }
    };

    publ.suspendResize = function(suspend)
    {
        if (typeof suspend === 'undefined')
        {
            suspend = true;
        }

        _pri.suspend_resize = suspend ? true : false;

        // resume ...
        if (!suspend)
        {
            publ.resize();
        }
    };

    publ.showErrMsg = function(errmsg, $elm)
    {
        $elm.html(_pri.err_html.replace(/\{ERRMSG\}/m, errmsg));

        if ($elm.offset)
        {
            $('html,body').animate({
                scrollTop: ($elm.offset().top - _pri.$nav_top.outerHeight(true))
            }, 350);
        }
    };

    publ.scrollToElm = function($elm)
    {
        if (typeof $elm === 'object' && $elm.length > 0)
        {
            $('html,body').animate({
                scrollTop: ($elm.offset().top - _pri.$nav_top.outerHeight(true))
            }, 350, function() {
                $elm.focus();
            });
        }
    };

    publ.hideErrMsg = function($elm)
    {
        $elm.empty();
    };

    _pri.disableEvent = function(e) {
        // _pri.dbg('!!! disable animation end events for ripple effect!');
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        return false;
    }

    _pri.ripple = function(e)
    {
        //_pri.dbg('******** ripple()');

        var $this, wcls, $wave, d, x, y, t;

        $this = $(this);
        if ($this.hasClass('rpl-d'))
        {
            wcls = 'rpl-wave-d';
        }
        else
        {
            wcls = 'rpl-wave';
        }

        //create wave element if it doesn't exist
        $wave = $this.find('.' + wcls);
        if ($wave.length == 0)
        {
            $wave = $('<span class="' + wcls + '"></span>').prependTo($this);
            // use parent's width or height whichever is larger for the diameter to make a circle which can cover the entire element.
            d = Math.max($this.outerWidth(), $this.outerHeight());
            $wave.css({height: d, width: d});

            $wave.on('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', _pri.disableEvent);
        }
        else
        {
            // in case of quick double clicks stop the previous animation
            // $wave.removeClass("anm");
            $wave.css({animation: ''});
        }

        // // set size of .ink
        // if(!$wave.height() && !$wave.width())
        // {
        //     // use parent's width or height whichever is larger for the diameter to make a circle which can cover the entire element.
        //     d = Math.max($this.outerWidth(), $this.outerHeight());
        //     $wave.css({height: d, width: d});
        // }

        // get click coordinates
        // logic = click coordinates relative to page - parent's position relative to page - half of self height/width to make it controllable from the center;
        x = e.pageX - $this.offset().left - $wave.width()/2;
        y = e.pageY - $this.offset().top - $wave.height()/2;

        // set the position and add class .animate
        // $wave.css({top: y+'px', left: x+'px'}).addClass("anm");animation: ripple 0.4s linear;
        t = Math.min(Math.round($wave.width()), 80);
        t = Math.max((t - 10), 20);
        t = (t / 100).toString() + 's';

        // t = '0.5s';

        // _pri.dbg('    ripple: ' + t);
        $wave.css({top: y+'px', left: x+'px', animation: 'ripple ' + t + ' ease-out'});
    };

    _pri.initRpl = function()
    {
        $(document).on('mousedown', '.rpl', _pri.ripple);
        // //Initialization
        // Waves.attach('.btn:not(.btn-flat), .btn-floating', ['waves-light']);
        // Waves.attach('.btn-flat', ['waves-effect']);
        // Waves.attach('.view a .mask', ['waves-light']);
        // Waves.attach('.waves-light', ['waves-light']);
        // Waves.attach('.rpl', ['waves-light']);
        // Waves.attach('.navbar-nav a:not(.navbar-brand), .nav-icons li a, .navbar input', ['waves-light']);
        // Waves.attach('.pager li a', ['waves-light']);
        // Waves.attach('.pagination .page-item .page-link', ['waves-effect']);
        // Waves.init();
    };

    _pri.initNavUsr = function()
    {
        var $umbtn = $('#umbtn');
        var $navu  = $('#nav-usr');

        if ($umbtn.length > 0)
        {
            $(document).on('click', function(e) {
                if ($navu.hasClass('in') && !$navu.is(e.target) && $navu.has(e.target).length === 0)
                {
                    $navu.removeClass('in').addClass('out');
                }
            });
            $umbtn.on('mouseenter', function() {
                _pri.dbg('umbtn mouseenter');
                if (!$navu.hasClass('in'))
                {
                    $navu.removeClass('out').addClass('in');
                }
            });

            $navu.on('mouseleave', function() {
                _pri.dbg('nav-usr mouseleave');
                $navu.removeClass('in').addClass('out');
            });
        }

    //     _pri.$nav = $('#nav-adm');
    //     _pri.$mnu = _pri.$nav.find('.mnu');
    //     if (_pri.$nav.length < 1)
    //     {
    //         _pri.$nav = null;
    //         return;
    //     }
    //
    //     _pri.$btn_nav = _pri.$nav.find('.mnu > .btn');
    //     _pri.$lnks = _pri.$nav.find('.lnks');
    //
    //     _pri.$mnu.on('mouseenter', function(e) {
    //         _pri.$lnks.removeClass('animated ' + 'slideOutUp adur025').show().animateCss('slideInDown adur025', function() {
    //             _pri.$lnks.css('visibility', 'visible');
    //         });
    //     });
    //
    //     _pri.$mnu.on('mouseleave', function(e) {
    //         _pri.$lnks.removeClass('animated ' + 'slideInDown adur025').animateCss('slideOutUp adur025', function() {
    //             _pri.$lnks.css('visibility', 'hidden');
    //         });
    //     });
    }

    // _pri.initAccos = function()
    // {
    //     $('.acco .panel-heading').click(function(e) {
    //         var $this = $(this);
    //         var $acco = $this.closest('.acco');
    //         var $panel = $this.closest('.panel');
    //         var $pbody = $panel.find('.collapse.acco-body');
    //         var $panels = $acco.find('.panel');
    //         var $pbodies = $panels.find('.collapse.acco-body');
    //
    //         if ($panel.hasClass('active'))
    //         {
    //             //_pri.dbg('active!!!', $pbody);
    //             $panel.removeClass('active');
    //             $pbody.stop( true, true ).slideUp("400", "swing");
    //             //$panel.trigger('acco:close');
    //         }
    //         else
    //         {
    //             if (!$acco.hasClass('mult'))
    //             {
    //                 //_pri.dbg('NOT active!!!', $pbody);
    //                 $panels.removeClass('active');
    //                 $pbodies.each(function(k, v) {
    //                     var $b = $(v);
    //                     //_pri.dbg('bbbbbbbbbbbbbbb', $b);
    //                     if ($b.get(0) !== $pbody.get(0))
    //                     {
    //                         $b.stop( true, true ).slideUp("400", "swing");
    //                         //$b.trigger('acco:close');
    //                     }
    //                 });
    //             }
    //             $panel.addClass('active');
    //             $pbody.stop( true, true ).slideDown("400", "swing");
    //         }
    //     });
    //
    //     $('.acco .panel').each(function() {
    //         var $this = $(this);
    //         if ($this.hasClass('active'))
    //         {
    //             $this.removeClass('active');
    //             $this.find('.panel-heading').trigger('click');
    //         }
    //     });
    //
    //     // $('.acco .panel').on('acco:close', function(e) {
    //     //     _pri.dbg('*** acco:close');
    //     //     var $this = $(this);
    //     //     var len = $this.find('input:checked').length;
    //     //     var txt = $this.find('h4.panel-title a').text().replace(/ \(\d+\)$/, '');
    //     //     if (len > 0)
    //     //     {
    //     //         txt = txt + ' (' + len + ')';
    //     //     }
    //     //     $this.find('h4.panel-title a').text(txt);
    //     // });
    // };

    _pri.initAccs = function()
    {
        $('.acc .card-header').click(function(e) {
            e.preventDefault();

            _pri.dbg('acc card-header click');
            var $this = $(this);
            var $card = $this.closest('.card');
            var $coll = $card.find('.collapse').first();
            // var $acc = $this.closest('.acc');

            if ($card.hasClass('opn') || $coll.hasClass('show'))
            {
                _pri.dbg('acc is open!!!');
                $card.removeClass('opn');
                $coll.collapse('hide');
                //$panel.trigger('acco:close');
            }
            else
            {
                _pri.dbg('acc is closed!!!');
                $card.addClass('opn');
                $coll.collapse('show');
                // if (!$acco.hasClass('mult'))
                // {
                //     //_pri.dbg('NOT active!!!', $pbody);
                //     $panels.removeClass('active');
                //     $pbodies.each(function(k, v) {
                //         var $b = $(v);
                //         //_pri.dbg('bbbbbbbbbbbbbbb', $b);
                //         if ($b.get(0) !== $pbody.get(0))
                //         {
                //             $b.stop( true, true ).slideUp("400", "swing");
                //             //$b.trigger('acco:close');
                //         }
                //     });
                // }
                // $panel.addClass('active');
                // $pbody.stop( true, true ).slideDown("400", "swing");
            }

            return false;
        });

        $('.acc .card').each(function() {
            var $this = $(this);
            if ($this.hasClass('opn'))
            {
                // $this.find('.collapse').first().collapse('show');
                $this.find('.collapse').first().addClass('show');
            }
        });
    };

    _pri.initAcc = function($acc)
    {
        $acc.find('.card-header').click(function(e) {
            e.preventDefault();

            _pri.dbg('acc card-header click');
            var $this = $(this);
            var $card = $this.closest('.card');
            var $coll = $card.find('.collapse').first();
            // var $acc = $this.closest('.acc');

            if ($card.hasClass('opn') || $coll.hasClass('show'))
            {
                _pri.dbg('acc is open!!!');
                $card.removeClass('opn');
                $coll.collapse('hide');
                //$panel.trigger('acco:close');
            }
            else
            {
                _pri.dbg('acc is closed!!!');
                $card.addClass('opn');
                $coll.collapse('show');
                // if (!$acco.hasClass('mult'))
                // {
                //     //_pri.dbg('NOT active!!!', $pbody);
                //     $panels.removeClass('active');
                //     $pbodies.each(function(k, v) {
                //         var $b = $(v);
                //         //_pri.dbg('bbbbbbbbbbbbbbb', $b);
                //         if ($b.get(0) !== $pbody.get(0))
                //         {
                //             $b.stop( true, true ).slideUp("400", "swing");
                //             //$b.trigger('acco:close');
                //         }
                //     });
                // }
                // $panel.addClass('active');
                // $pbody.stop( true, true ).slideDown("400", "swing");
            }

            return false;
        });

        $acc.find('.card').each(function() {
            var $this = $(this);
            if ($this.hasClass('opn'))
            {
                $this.find('.collapse').first().collapse('show');
            }
        });
    };

    _pri.initInputs = function()
    {
        _pri.dbgG('*** initInputs()');
        // nai: no auto init
        var $input = $('.ta-tx:not(.nai)');
        $.each($input, function(k, v) {
            //_pri.dbg(k);
            //_pri.dbg(v);
            JW.TATextInput(jQuery, v);
        });
        // nai: no auto init
        $input = $('.jb-select:not(.nai)');
        _pri.dbg('    jb-selects:',$input );
        $.each($input, function(k, v) {
            //_pri.dbg(k);
            //_pri.dbg(v);
            JW.InpSelect(jQuery, v);
        });
        // nai: no auto init
        $input = $('.cltree:not(.nai)');
        $.each($input, function(k, v) {
            //_pri.dbg(k);
            //_pri.dbg(v);
            JW.ClTree(jQuery, v);
        });
    };

    _pri.initCbds = function()
    {
        var $cbdedt = $('#cbd');
        var $jobfrm = $('#cbd-frm-bot');
        if ($cbdedt.length > 0)
        {
            JW.Cbd(jQuery, $cbdedt[0]);
        }
        else if ($jobfrm.length > 0)
        {
            JW.JobFrm(jQuery, $jobfrm[0]);
        }
        // var $cbd = $('.cbd');
        // $.each($cbd, function(k, v) {
        //     //_pri.dbg(k);
        //     //_pri.dbg(v);
        //     JW.Cbd(jQuery, v);
        // });
    };

    publ.initSld = function(sld, cbf)
    {
        const jwsld    = {};
        jwsld.sld      = sld;
        jwsld.cbf      = cbf;
        jwsld.$sld     = $(sld);
        // jwsld.$wrp_val = jwsld.$sld.parent().find('.jw-slider-val');

        jwsld.updSlider = function()
        {
            jwsld.sld.style.setProperty('--sld-bgsz', `${jwsld.getBackgroundSize()}%`);

            if (typeof jwsld.cbf === 'function')
            {
                cbf(jwsld.$sld);
            }
            // else
            // {
            //     jwsld.$wrp_val.text($sld.val());
            // }
        };

        jwsld.getBackgroundSize = function()
        {
            const min = +jwsld.sld.min || 0;
            const max = +jwsld.sld.max || 100;
            const val = +jwsld.sld.value;

            const size = (val - min) / (max - min) * 100;

            return size;
        }

        jwsld.updSlider();
        jwsld.$sld.on('input', jwsld.updSlider);

        // jwsld.$sld.data('jwsld', jwsld)
    };

    _pri.initSlds = function()
    {
        let $slds = $('.jw-slider:not(.nai)');
        if ($slds.length > 0)
        {
            _pri.dbg('*** slds length:', $slds.length);

            $.each($slds, function(k, v) {
                publ.initSld(v);
            });
        }
    }

    // now done by clsacc
    // _pri.initDstSlds = function()
    // {
    //     var $dst_wrps = $('.dist-wrp:not(.nai)');
    //
    //     $.each($dst_wrps, function(k, v) {
    //         var $dst_wrp = $(v);
    //         var $dst_inp = $dst_wrp.find('input[type="range"]');
    //
    //         if ($dst_inp.length == 1)
    //         {
    //             var $lgd_cur = $dst_wrp.find('.dist-cur');
    //             if ($lgd_cur.length == 1)
    //             {
    //                 $dst_inp.rangeslider({
    //                     polyfill: false,
    //                     // onInit: _pri.updDstSld,
    //                     onSlide: _pri.updDstSld,
    //                     onSlideEnd: _pri.updDstSld,
    //                     $lgd_cur: $lgd_cur,
    //                     unt: $dst_inp.data('unt')
    //                 });
    //                 $dst_inp.rangeslider('update', true);
    //                 _pri.dbg('*** _pri.initDstSlds ... done');
    //             }
    //             else
    //             {
    //                 $dst_inp.rangeslider({
    //                     polyfill: false
    //                 });
    //             }
    //         }
    //     });
    // };
    //
    // _pri.updDstSld = function(pos, val)
    // {
    //     // _pri.dbg('updDstSld()', pos, val);
    //     // var $this = $(this);
    //     // _pri.dbg(this);
    //     if (typeof this.options.$lgd_cur !== 'undefined' && this.options.$lgd_cur.length == 1)
    //     {
    //         this.options.$lgd_cur.html(val + ' ' + this.options.unt);
    //     }
    // };

    _pri.initMapVals = function()
    {
        _pri.dbg('*** initMapVals()');

        _pri.$col_left     = $('#col-left');
        _pri.$col_map      = $('#col-map');
        _pri.$col_right    = $('#col-right');

        _pri.$ffx          = $('#nav-ffx');

        _pri.$ccols        = $('.ccols');
        _pri.$map          = $('#map');
        _pri.$mfrm         = $('#mfrm');

        _pri.$ccol         = $('#ccol');

        _pri.map_inited    = false;
    };

    _pri.initMapView = function()
    {
        _pri.dbgG('*** initMapView()');

        if (_pri.isObj(JW.Map))
        {
            _pri.dbg('    JW.Map isObj ...');
            _pri.dbg('    calling JW.MapSForm.init() JW.MapList.init() ...');

            _pri.mods.delete('MAP');
            _pri.mods.delete('MAPSFORM');

            _pri.setScrlForce(true);

            setTimeout(function() {

                _pri.initMapVals();
                _pri.whbuff = 0;
                _pri.resize();

            }, 200);
        }
    };

    _pri.initMapWidgets = function()
    {
        var $mws = $('.mapwidget:not(.nai)');

        if ($mws.length > 0)
        {
            JW.Mapwidget(jQuery, $mws[0]);
        }
    };

    _pri.initAjxForms = function($elm)
    {
        //_pri.dbg('*** initAjxForms()');
        var $frms;
        if (typeof $elm !== 'object')
        {
            $frms = $('form.afrm');
        }
        else
        {
            $frms = $elm.find('form.afrm');
        }

        $.each($frms, function(k, v) {
            //_pri.dbg(k);
            //_pri.dbg(v);
            JW.AjxFrm(jQuery, v);
        });
    };

    _pri.initRatings = function()
    {
//         $('.rating-list-wrp').find('input').rating({
//             theme: '',
//             emptyStar: '<i class="glyphicon glyphicon-star"></i>',
//             language: 'de',
//             displayOnly: true,
//             size: 'xs'
//         });
        $('.rating-list-wrp').each(function() {
            var $this = $(this);
            var sz = $this.data('size');
            if (typeof sz === 'undefined' || !sz)
            {
                sz = 'xs';
            }
            $this.find('input').rating({
                theme: '',
                emptyStar: '<i class="glyphicon glyphicon-star"></i>',
                language: 'de',
                displayOnly: true,
                size: sz
            });
        });
    };

    _pri.initCbToggles = function()
    {
        $('a.cb-toggle').each(function(k, v) {
            var $this = $(this);
            var cb_class = $this.data('target-class');
            var $cbs = $('input[type="checkbox"].' + cb_class);

            $this.on('click', function(e) {
                e.stopPropagation();
                e.preventDefault();
                var $unc = $cbs.not(':checked');
                if ($unc.length > 0)
                {
                    $unc.prop('checked', true);
                    $this.html('keine');
                }
                else
                {
                    $cbs.prop('checked', false);
                    $this.html('alle');
                }
            });

            $cbs.on('change', function() {
                //_pri.dbg('on change');
                var $unc = $cbs.not(':checked');
                if ($unc.length > 0)
                {
                    $this.html('alle');
                }
                else
                {
                    $this.html('keine');
                }
            });
        });
    };

    _pri.initRadioToggles = function()
    {
        var $tgl_rbs = $('input._tgl[type="radio"]');

        $tgl_rbs.each(function(k, v) {
            var $this = $(this);
            if ($this.is(':checked'))
            {
                var nm = $this.attr('name');
                $("input[name=" + nm + "]:radio").attr('prev_checked', false);
                $this.attr('prev_checked', 'checked');
            }
        });

        $tgl_rbs.on('click', function(e) {
            var $this = $(this);
            //_pri.dbg('******** initRadioToggles() clicked', $this.is(':checked'));

            var prev_checked = $this.attr('prev_checked');
            var nm = $this.attr('name');

            if (prev_checked == 'checked')
            {
                $this.removeAttr('checked');
                $this.attr('prev_checked', false);
                $this.trigger('change');
            }
            else
            {
                $("input[name=" + nm + "]:radio").attr('prev_checked', false);
                $this.attr('prev_checked', 'checked');
            }
        });
    };

    _pri.initFileBtns = function()
    {
        $('.jw-file-btn').each(function(k, v) {
            var $this = $(this);
            publ.initFileBtn($this);
        });
    };

    publ.initFileBtn = function($this)
    {
        // _pri.dbg('*** initFileBtn()');
        // _pri.dbg('    data pvgt: ', $this.data('pvtgt'));

        var fbtn = {};
        fbtn.$file_inp = $this.find('input[type="file"]');
        fbtn.$txt_inp = $this.find('input[type="text"]');
        fbtn.$pvtgt = $($this.data('pvtgt'));

        // we can't really rely on reported file.type by filereader, it determines type only by extension
        // for a more reliable client side check see:
        // https://stackoverflow.com/questions/18299806/how-to-check-file-mime-type-with-javascript-before-upload

        if (fbtn.$pvtgt.length > 0)
        {
            fbtn.$pv_img = fbtn.$pvtgt.find('.pv-img');
            fbtn.addcls  = 'show animated fadeIn fimg';
            if (typeof $this.data('pvcls') === 'string')
            {
                fbtn.addcls += ' ' + $this.data('pvcls');
            }
        }

        // data-mxw, data-mxh : max width/height
        fbtn.mxw = '', fbtn.mxh = '';
        if (typeof $this.data('mxw') != 'undefined')
        {
            fbtn.mxw = $this.data('mxw');
        }
        if (typeof $this.data('mxh') != 'undefined')
        {
            fbtn.mxh = $this.data('mxh');
        }
        fbtn.img_style = '';
        if (fbtn.mxw != '')
        {
            fbtn.img_style = 'max-width:' + fbtn.mxw + ';';
        }
        if (fbtn.mxh != '')
        {
            fbtn.img_style += 'max-height:' + fbtn.mxh + ';';
        }

        // hidden input name
        fbtn.hbn = '';
        if (typeof $this.data('hbn') != 'undefined' && $this.data('hbn'))
        {
            fbtn.hbn = $this.data('hbn');
        }

        fbtn.$txt_inp.on('focus', function(e) {
            fbtn.$txt_inp.blur();
            fbtn.$file_inp.trigger('click');
        });

        fbtn.hasImgPreview = function()
        {
            return (fbtn.$pvtgt.length > 0 && fbtn.$pv_img.length > 0);
        };
        fbtn.hasHiddenInputs = function()
        {
            return (fbtn.hbn != '');
        };

        fbtn.$file_inp.on('change', function(e) {
            _pri.dbg('*** file-btn change');
            if (fbtn.hasImgPreview())
            {
                // _pri.dbg('    has hasImgPreview() ...');
                fbtn.$pvtgt.removeClass('show animated fadeIn');
                fbtn.$pv_img.empty();
            }
            if (fbtn.hasHiddenInputs())
            {
                // $this.find('input[name^="' + fbtn.hbn + '"]').remove();
                $this.find('input[type="hidden"]').remove();
            }

            var f_cnt = fbtn.$file_inp.get(0).files ? fbtn.$file_inp.get(0).files.length : 1;
            _pri.dbg('    f_cnt: ', f_cnt);
            var label = fbtn.$file_inp.val().replace(/\\/g, '/').replace(/.*\//, '');
            var txt = f_cnt > 1 ? f_cnt + ' Dateien ausgewählt' : label;
            fbtn.$txt_inp.val(txt);

            if (f_cnt > 0)
            {
                var i;
                var len = e.target.files.length;
                var files_arr = [];

                for (i = 0; i < len; ++i)
                {
                    files_arr.push(i);
                }

                files_arr.forEach(function (v, k) {

                    var file, fr;

                    file = e.target.files[v];

                    _pri.dbg('    file: ', file.type);

                    if (fbtn.hasHiddenInputs())
                    {
                        if (len > 1)
                        {

                        }
                        else
                        {

                        }
                        var hnm     = fbtn.hbn.toString() + '' + v; // hidden name, base name + iterator
                        var hlb     = hnm + '_lbl';
                        var hnm_lbl = file.name;
                    }

                    _pri.dbg('    hnm: ', hnm);

                    var ftype = file.type;

                    fr = new FileReader();
                    fr.onload = function(e) {
                        _pri.dbg('*** FileReader.onload() e:', e);
                        if (fbtn.hasImgPreview())
                        {
                            if (/^image\/(png|jpeg|webp)/.test(ftype))
                            {
                                $('<img>').attr({
                                    src: fr.result,
                                    style: fbtn.img_style,
                                    class: 'img-fluid'
                                }).appendTo(fbtn.$pv_img);
                                fbtn.$pvtgt.addClass(fbtn.addcls);
                            }
                        }
                        if (fbtn.hasHiddenInputs())
                        {
                            $('<input>').attr({
                                type: 'hidden',
                                name: hnm,
                                // value: fr.result.replace(/^data:image\/(png|jpeg);base64,/, '') // the server has to take care of that anyway ...
                                value: fr.result
                            }).appendTo($this);
                            $('<input>').attr({
                                type: 'hidden',
                                name: hlb,
                                // value: fr.result.replace(/^data:image\/(png|jpeg);base64,/, '') // the server has to take care of that anyway ...
                                value: hnm_lbl
                            }).appendTo($this);
                        }
                    };
                    //fr.readAsText(file);
                    fr.readAsDataURL(file);
                });

                // for (i = 0; i < len; ++i)
                // {
                //     file = e.target.files[i];
                //
                //     _pri.dbg('    file: ', file.type);
                //
                //     if (fbtn.hasHiddenInputs())
                //     {
                //         var hnm = fbtn.hbn.toString() + '' + i; // hidden name, base name + iterator
                //     }
                //
                //     _pri.dbg('    hnm: ', hnm);
                //
                //     var ftype = file.type;
                //
                //     fr = new FileReader();
                //     fr.onload = function(e) {
                //         _pri.dbg('*** FileReader.onload() e:', e);
                //         if (fbtn.hasImgPreview())
                //         {
                //             if (/^image\/(png|jpeg)/.test(ftype))
                //             {
                //                 $('<img>').attr({
                //                     src: fr.result,
                //                     style: fbtn.img_style,
                //                     class: 'img-fluid'
                //                 }).appendTo(fbtn.$pv_img);
                //                 fbtn.$pvtgt.addClass(fbtn.addcls);
                //             }
                //         }
                //         if (fbtn.hasHiddenInputs())
                //         {
                //             $('<input>').attr({
                //                 type: 'hidden',
                //                 name: hnm,
                //                 // value: fr.result.replace(/^data:image\/(png|jpeg);base64,/, '') // the server has to take care of that anyway ...
                //                 value: fr.result
                //             }).appendTo($this);
                //         }
                //     };
                //     //fr.readAsText(file);
                //     fr.readAsDataURL(file);
                // }
            }
        });

        fbtn.reset = function()
        {
            fbtn.$file_inp.val('');
            fbtn.$txt_inp.val('');
            if (fbtn.hasHiddenInputs())
            {
                // $this.find('input[name^="' + fbtn.hbn + '"]').remove();
                $this.find('input[type="hidden"]').remove();
            }
        };

        fbtn.resetPv = function()
        {
            if (fbtn.hasImgPreview())
            {
                fbtn.$pvtgt.removeClass(fbtn.addcls);
                fbtn.$pv_img.empty();
            }
        };

        $this.data('fbtn', fbtn);
    };

    _pri.initWClouds = function()
    {
        //_pri.dbg('******** initWClouds()');
        var $wcs = $('#wcloud');
        if (0 < $wcs.length)
        {
            //(url, cb, arg)
            publ.loadJS('/cln/js/jw_wcloud.min.js', _pri.onLoadWCloud, $wcs);
            /* comment above line and uncomment below for dev
             _pri.onLoadWCloud($wcs);
            */
        }
    };

    _pri.onLoadWCloud = function($wcs)
    {
        //_pri.dbg('******** onLoadWCloud()');
        $.each($wcs, function(k, v) {
            //_pri.dbg(k);
            //_pri.dbg(v);
            JW.WCloud(jQuery, v);
        });
    };

    publ.initPdfWrps = function(sel)
    {
        var $sel = $(sel);
        if (_pri.pdfs_inited && _pri.pdfs_loaded === 0)
        {
            _pri.initPdfWrps = function()
            {
                var $pdfwrps = $sel.find('.pdfwrp');
                $.each($pdfwrps, function(k, v) {

                    JW.Pdf(jQuery, v);

                });
            };
            _pri.initPdfs();
        }
        else if (_pri.pdfs_inited && _pri.pdfs_loaded === 2)
        {
            var $pdfwrps = $sel.find('.pdfwrp');
            $.each($pdfwrps, function(k, v) {

                JW.Pdf(jQuery, v);

            });
        }
    };

    _pri.initPdfs = function()
    {
        _pri.dbg('******** initPdfs()');

        var $pdfwrps = $('.pdfwrp');
        var $cbdedt = $('#cbd');
        if (0 < $pdfwrps.length || 0 < $cbdedt.length)
        {
            _pri.pdfs_loaded = 1;
            //TODO minify in package ... or not - it's pretty tiny ... and we can still get rid of most of it (annotions etc ...)
            // publ.loadCSS('/cln/pdf-2.0.493/web/pdf_viewer.css');

            srcs = {};
            _pri.dbg('*** _pri.opts.env_dev: ', _pri.opts.env_dev);
            if (!_pri.opts.env_dev)
            {
                srcs = {
                    pkg_src: '/cln/pdf/jw_pdf_pkg.min.js'

                };

                var allcnt = Object.keys(srcs).length;

                $.each(srcs, function(k, v) {
                    _pri.dbg('    ... loading pdf package: ' + v);
                    publ.loadJS(v, _pri.onLoadPdfs, allcnt);
                });
            }
            else
            {
                // JW.Pdfs.init();
                _pri.pdfs_loaded = 2;
                _pri.initPdfWrps();
            }
        }
    };

    _pri.onLoadPdfs = function(allcnt, e)
    {
        _pri.dbg('******** onLoadPdfs() e:',  e);
        _pri.dbg('    allcnt:',  allcnt);

        if (typeof _pri.onLoadPdfs.cnt === 'undefined')
        {
            _pri.onLoadPdfs.cnt = 0;
        }

        ++_pri.onLoadPdfs.cnt;
        _pri.dbg('    cnt: ', _pri.onLoadPdfs.cnt);

        if (allcnt == _pri.onLoadPdfs.cnt)
        {
            // JW.Pdfs.init();
            _pri.pdfs_loaded = 2;
            _pri.initPdfWrps();
        }
    };

    _pri.initPdfWrps = function()
    {
        var $pdfwrps = $('.pdfwrp:not(.nai)');
        $.each($pdfwrps, function(k, v) {

            JW.Pdf(jQuery, v);

        });
    };

    _pri.initGll = function()
    {
        // var $gll = $('#gll');
        // if (0 < $gll.length)
        // {
        //     $.each($gll, function(k, v) {
        //         JW.Gll(jQuery, v);
        //     });
        // }

        JW.JWGll.init();
    };

    _pri.initLive = function()
    {
        if (typeof JW.Live === 'object')
        {
            if (typeof JW.LiveAdmExt === 'function' && $('#wrp_live_adm').length > 0)
            {
                JW.Live.extend(JW.LiveAdmExt);
            }

            JW.Live.init();
        }
    };

    _pri.initSioc = function()
    {
        if (typeof JW.SiocLive === 'object')
        {
            JW.SiocLive.init();
        }
        if (typeof JW.SiocAdm === 'object')
        {
            JW.SiocAdm.init();
        }
    }

    // _pri.initGll = function()
    // {
    //     _pri.dbg('******** initGll()');
    //     // var $gll = $('#gll');
    //     // if (0 < $gll.length)
    //     // {
    //     //     //(url, cb, arg)
    //     //     // publ.loadJS('/cln/src/gll/jw_gll_carousel.js', _pri.onLoadGll, $gll);
    //     //     $.each($gll, function(k, v) {
    //     //         //_pri.dbg(k);
    //     //         //_pri.dbg(v);
    //     //         JW.Gll(jQuery, v);
    //     //     });
    //     // }
    // };

    // _pri.onLoadGll = function($gll)
    // {
    //     _pri.dbg('******** onLoadGll()');
    //     $.each($gll, function(k, v) {
    //         //_pri.dbg(k);
    //         //_pri.dbg(v);
    //         JW.Gll(jQuery, v);
    //     });
    // };

    // axj calls for actions called by url param
    _pri.pOnl = function()
    {
        _pri.dbg('******** pOnl()');
        if ('login' == _pri.ponl)
        {
            JW.Modal.closeGet('/login');
        }
        else if ('preise' == _pri.ponl)
        {
            JW.Modal.closeGet('/preise');
        }
        else if (typeof _pri.ponl === 'object')
        {
            if (typeof _pri.ponl._jsnret !== 'undefined' && _pri.ponl._jsnret)
            {
                JW.Modal.handleJSONRet(_pri.ponl);
            }
            else
            {
                JW.Modal.onJsSet(_pri.ponl);
            }
        }
    };

    // auto load ajax html
    _pri.initAld = function($elm)
    {
        // _pri.dbg('******** initAld()');
        var $alds;
        if (typeof $elm !== 'object')
        {
            $alds = $('.ald');
            // _pri.dbg('    global');
        }
        else
        {
            $alds = $elm.find('.ald');
        }

        if (0 < $alds.length)
        {
            // _pri.dbg('    found ...');
            $.each($alds, function(k, v) {
                var $tgt = $(v);
                var url  = $tgt.data('url');

                if (typeof url != 'undefined')
                {
                    // _pri.dbg('    url:', url);
                    var opts = {
                        type: 'GET',
                        url: url,
                        dataType: 'html'
                    };

                    $.ajax(opts).done(function(ret, stat_str, jq_xhr) {
                        _pri.dbg('*** ald (' + opts.url + ') done');
                        // _pri.dbg('    ret:', ret);
                        if (jq_xhr.status == 200)
                        {
                            // publ.setPart('mco_geo', ret);
                            $tgt.html(ret);
                            _pri.initAjxForms($tgt);
                        }
                    });
                }
            });
        }
    };

    _pri.initMutObs = function()
    {
        let $obs = $('.mutobs');

        if ($obs.length > 0)
        {
            _pri.setMutObs($obs);
        }
    };

    _pri.setMutObs = function($elms)
    {
        if ($elms.length > 0)
        {
            if (_pri.mutObs == null)
            {
                _pri.dbgG('*** initMutObs()');
                _pri.mutObs = new MutationObserver(function(mutation_list, observer) {
                    _pri.dbgG('*** observer callback()');
                    // _pri.dbg('    mutation_list:', mutation_list);
                    // _pri.dbg('    target:', mutation_list[0].target);

                    let $tgt = $(mutation_list[0].target);
                    if ($tgt.length > 0)
                    {
                        let cll  = $tgt.data('cll');
                        if (_pri.isObj(cll))
                        {
                            JW.Modal.handleJSONRet(cll);
                        }
                    }
                });
            }

            $.each($elms, function(k, v) {

                let $tgt = $(v);

                if ($tgt.length > 0)
                {
                    let cnf  = $tgt.data('cnf');
                    let mutobsdone = $tgt.data('mutobsdone');
                    if (typeof mutobsdone !== 'undefined' && mutobsdone)
                    {
                        _pri.dbgG('    mutationobserver already done');
                    }
                    else if (_pri.isObj(cnf))
                    {
                        _pri.mutObs.observe(v, cnf);
                        _pri.setDataAttr($tgt, 'mutobsdone', true);
                    }
                }
            });
        }
    };

    _pri.initECll = function($elm)
    {
        _pri.dbgG('*** initECll()');

        let $eclls = null;

        if (typeof $elm === 'string' && $elm == 'PAGE_INIT')
        {
            $eclls = $('.ecll');
        }
        else if (typeof $elm === 'object' && _pri.isObj($elm) && $elm.length > 0)
        {
            $eclls = $elm.find('.ecll');
        }

        if (_pri.isObj($eclls) && $eclls.length > 0)
        {
            $.each($eclls, function(k, v) {

                let $e = $(v);

                if ($e.length > 0)
                {
                    let cll  = $e.data('cll');
                    if (_pri.isObj(cll))
                    {
                        _pri.dbg('    call cll()');
                        JW.Modal.cll(cll);
                    }
                }
            });
        }
    };

    _pri.initEvents = function()
    {
        JW.Page.on('module:init_done', function(e, o) {

            _pri.dbg('*** on module:init_done() o:', o, 'o.mod:', o.mod, 'mods:', _pri.mods);

            if (_pri.mods.has(o.mod)) //(-1 != $.inArray(o.mod, mods))
            {
                //_pri.dbg('!!! module:init_done triggered twice from: ' + o.mod + '!');
            }
            else
            {
                _pri.mods.set(o.mod, 1);
                if (_pri.mods.has('MAPSFORM') && _pri.mods.has('MAP') ) //(-1 != $.inArray('MAPSFORM', mods) && -1 != $.inArray('MAP', mods))
                {
                    _pri.dbgB('MAPSFORM and MAP loaded ...');
                    JW.MapSForm.initQuest();
                }
            }
        });

        // window.onunload = function(){};

        window.addEventListener('message', function(e) {

            _pri.dbgR('*** window on message() e:', e);
            _pri.dbgR('    e.origin:', e.origin);
            _pri.dbgR('    e.data:', e.data);
            // if (e.origin != 'http://unknown.tld')
            // {
            //     // something from an unknown domain, let's ignore it
            //     return;
            // }

            // can message back using event.source.postMessage(...)

            publ.trigger('page:window_on_message', e);
        });

        // refresh captcha ...
        $(document).on('click', '.rcpt', function(e) {
            var $this = $(this);
            var $img = $($this.data('cpti'));
            if ($img.length === 1)
            {
                var cptk = $this.data('cptk') || '';
                $img.attr('src', '/cpt/' + cptk + '?rnd=' + publ.getUId(8));
            }
        });

        // $(document).on('keyup', function(e) {
        //
        //     if (e.keyCode == 32)
        //     {
        //         $(e.target).trigger('keyspace');
        //     }
        // });
        $(document).on('keydown', function(e) {

            if (e.keyCode == 13)
            {
                $(e.target).trigger('keyenter');
            }
            else if (e.keyCode == 32)
            {
                $(e.target).trigger('keyspace');
            }
        });

        $(document).on('keydown', '.kent', function(e) {

            if (e.keyCode == 13)
            {
                _pri.dbg('*** on.keydown .kent');
                let tgt = $(this).data('tgt');
                let ev  = $(this).data('ev');
                if (typeof tgt !== 'undefined' && typeof ev !== 'undefined')
                {
                    _pri.dbg('    trigger ...');
                    $(tgt).trigger(ev);
                }
            }
        });

        $(document).on('mouseenter', '.hov', function(e) {
            // _pri.dbg('*** .hov in ...');
            let $tgt = [];
            let tgt = $(this).data('tgt');
            if (typeof tgt !== 'undefined')
            {
                $tgt = $(tgt);
            }
            else
            {
                $tgt = $(this);
            }

            if ($tgt.length > 0)
            {
                $tgt.addClass('hover');
            }
        });

        $(document).on('mouseleave', '.hov', function(e) {
            // _pri.dbg('*** .hov out ...');
            let $tgt = [];
            let tgt = $(this).data('tgt');
            if (typeof tgt !== 'undefined')
            {
                $tgt = $(tgt);
            }
            else
            {
                $tgt = $(this);
            }

            if ($tgt.length > 0)
            {
                $tgt.removeClass('hover');
            }
        });

        publ.on('live:live_lnk_on_load', _pri.liveLnkOnLoad);
    };

    _pri.liveLnkOnLoad = function(e, ret)
    {
        _pri.dbgG('*** liveLnkOnLoad() ret:', ret);

        if (_pri.isObj(ret) && typeof ret.elmi === 'undefined' || typeof ret.elmi['#map'] === 'undefined')
        {
            _pri.dbgR('    no mapview!');
            _pri.setScrlForce(false);
            $('#nav-bot').removeClass('map_view');
        }
    };

    _pri.extend();

    // expose public methods
    return publ;
})(jQuery);